import { CardHeaderHover } from './CardHeader';
import { Box } from '@openfin/ui-library';
import styled from 'styled-components';

export const Card = styled(Box)<{ hasButtons?: boolean; isUpdate?: boolean }>`
  flex-direction: column;
  user-select: none;
  width: 312px;
  position: relative;
  padding: ${({ theme }) => theme.px.base};
  min-height: ${({ hasButtons }) => hasButtons && '128px'};
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.background4};
  box-shadow: ${({ theme }) => theme.shadow.base};
  border-radius: ${({ theme }) => theme.radius.base};
  overflow: hidden;

  ${CardHeaderHover}
`;
